import React, { useEffect, useState } from 'react';
import API_BASE_URL from "Components/API";
import Loading from "Components/Loading";
import { useTranslation } from "react-i18next";
import axios from 'axios';
import parse from 'html-react-parser';
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";
import { ReactComponent as DerivativeMarket } from "Assets/icons/derivativeMarket.svg";
import { ReactComponent as PowerMarket } from "Assets/icons/powerMarket.svg";
import { ReactComponent as PhysicalMarket } from "Assets/icons/physicalMarket.svg";
import { ReactComponent as OtherTradableSecurities } from "Assets/icons/otherTradableSecurities.svg";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import FactCheckIcon from '@mui/icons-material/FactCheck';
const SpecializedCommittee = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;

    return (
        <div className="megaMenuContent">
            <div className="row h-100">
                <div className="col-4 d-flex justify-content-center align-items-center">
                    <a href="/SpecializedCommittee/#audit-specialized" className="tradesFeeItems py-2 px-4 w-100 text-center">
                        <AnalyticsIcon className="max-width-100 mx-2 d-inline-block" />

                        {t('audit_specialized_committee')}
                    </a>
                </div>
                <div className="col-4 d-flex justify-content-center align-items-center">
                    <a href="/SpecializedCommittee/#appointments-specialized" className="tradesFeeItems py-2 px-4 w-100 text-center">
                        <AssignmentIndIcon className="max-width-100 mx-2 d-inline-block" />
                        {t('appointments_specialized_committee')}
                    </a>
                </div>
                <div className="col-4 d-flex justify-content-center align-items-center">
                    <a href="/SpecializedCommittee/#strategic-and-risk-management" className="tradesFeeItems py-2 px-4 w-100 text-center">
                        <FactCheckIcon className="max-width-100 mx-2 d-inline-block" />
                        {t('strategic_and_risk_management_specialized_committee')}
                    </a>
                </div>
                <div className="col-12 text-start mt-2 align-self-end">
                    <a href="/SpecializedCommittee" target="_blank" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1" >
                        {t('view_committee_members_info')}
                        <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                            {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}
                        </span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default SpecializedCommittee;
